import { useState } from "react";
import { BaseDialog } from "./BaseDialog";

function UndefeatedDialog({ modalTitle = "Can you go undefeated?" }) {
  const [isOpen, setIsOpen] = useState(true);

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <BaseDialog
        isOpen={isOpen}
        closeModal={closeModal}
        modalTitle={modalTitle}
        modalBody={<HowToPlayBody />}
        size="md"
      />
    </>
  );
}

function HowToPlayBody() {
  return (
    <div className="my-2 space-y-4 px-2 pt-2 text-md sm:px-4">
      <div>
        Think you can build the perfect team? Play{" "}
        <a
          className="font-medium text-blue-600 hover:underline"
          href="https://23-0.com/?utm_source=gridley&utm_medium=affiliate&utm_campaign=modal"
          target="_blank"
        >
          23-0
        </a>
        !
      </div>

      <div className="flex w-full items-center overflow-hidden">
        <a
          className="font-medium text-blue-600 hover:underline"
          href="https://23-0.com/?utm_source=gridley&utm_medium=affiliate&utm_campaign=modal"
          target="_blank"
        >
          <img src="/img/partners/undefeated/undefeated-social.png" />
        </a>
      </div>
      <div className="pl-0">
        <ul>
          <li>✅ &nbsp;Pick 5 legends from every era</li>
          <li>
            💯 &nbsp;See your team's{" "}
            <span className="hidden sm:inline-block">projected</span> win-loss
            record
          </li>
          <li>
            📣 &nbsp;Go{" "}
            <span className="hidden sm:inline-block">a perfect</span> 23-0 and
            show off your score
          </li>
        </ul>
      </div>
      <div>
        Time to go perfect at{" "}
        <a
          className="font-medium text-blue-600 hover:underline"
          href="https://23-0.com/?utm_source=gridley&utm_medium=affiliate&utm_campaign=modal"
          target="_blank"
        >
          23-0.com
        </a>
        !
      </div>
    </div>
  );
}

export default UndefeatedDialog;
